/* eslint import/no-cycle: 0 */
/* eslint no-console: 0 */
/* eslint react-hooks/exhaustive-deps: 0 */
import React, { useEffect, useState } from 'react'
import { useLoading } from '../../../../../presentation/contexts/loading'
import { useMe } from '../../../../../presentation/contexts/me'
import { usePage } from '../../../../../presentation/contexts/page'
import ClientsAssessmentsList from '../../../../../presentation/pages/dashboard/clients-assessments/list'
import { makeAssessment } from '../../../../usecases/assessments/load-assessment-factory'

export type StarFeedback = {
  id: number;
  question: string;
  amount: number;
  sum: number;
}

const MakeClientAssessmentList = () => {
  const { setHeader } = usePage()
  const { me } = useMe()
  const { onSetLoading } = useLoading()
  const [assessments, setAssessments] = useState<any[]>([])

  const starFeedbacks = assessments.reduce((
    acc: StarFeedback[],
    current: any,
  ) => {
    if (current.assessment.kind !== 2) return acc
    let newFeedback
    const alreadyAccumulated = acc.findIndex((feedback: any) => (
      feedback?.id === current.assessment?.id
    ))
    if (alreadyAccumulated > -1) {
      const amount = acc[alreadyAccumulated].amount + 1
      const sum = acc[alreadyAccumulated].sum + Number(current.answer)
      newFeedback = {
        id: current.assessment.id,
        question: current.assessment.title,
        amount,
        sum,
      }
      acc[alreadyAccumulated] = newFeedback
      return acc
    }

    newFeedback = {
      id: current.assessment.id,
      question: current.assessment.title,
      amount: 1,
      sum: Number(current.answer),
    }
    return [...acc, newFeedback]
  }, [])

  const filteredAssessments = assessments.filter((feedback: any) => (
    feedback.assessment.kind !== 2
  ))

  const loadAnswers = async () => {
    try {
      if (!me) return
      const stablishmentId = me.stablishments[0].id
      const response = await makeAssessment(stablishmentId).loadAnswers()
      setAssessments(response.assessments)
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    (async () => {
      setHeader({
        title: 'Avaliações dos clientes',
        goTo: null,
      })
      onSetLoading(true)
      await loadAnswers()
      onSetLoading(false)
    })()
  }, [me, setHeader])

  return (
    <ClientsAssessmentsList
      starFeedbacks={starFeedbacks}
      assessments={filteredAssessments}
    />
  )
}

export default MakeClientAssessmentList
